
import { Component, Emit, Prop } from 'vue-property-decorator';
import { Validations } from 'vuelidate-property-decorators';
import { maxLength, required } from 'vuelidate/lib/validators';
import FormInput from '@/components/form/FormInput.vue';
import FormValidationMixin from '@/mixins/FormValidationMixin';
import { mixins } from 'vue-class-component';
import { Sheet } from '@/model/Sheet';

@Component({
    components: {
        FormInput,
    },
})
export default class CreateSheetForm extends mixins(FormValidationMixin) {
    @Prop({ default: () => ({} as Sheet) }) sheet!: Sheet;

    formData = {
        ...this.sheet,
    } as Sheet;

    submitted = false;

    @Validations()
    validations = {
        formData: {
            name: {
                required,
                maxLength: maxLength(150),
            },
        },
    };

    @Emit()
    submit(): Sheet {
        return this.formData;
    }

    onSubmit(): void {
        this.submitted = true;
        this.$v.formData.$touch();
        if (!this.$v.$invalid) {
            this.submit();
        }
    }
}
